































import { Component, Mixins } from "vue-property-decorator";
import { PromptTemplate, DefaultPromptTemplate } from "#/model/admin/index";
import PromptTemplateEditor from "@/components/aimonthreport/PromptTemplateEditor.vue";
import PromptTemplateExperiment from "@/components/aimonthreport/PromptTemplateExperiment.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({
  components: {
    PromptTemplateEditor,
    PromptTemplateExperiment,
  },
})
/** プロンプトテンプレート編集 */
export default class AiMonthReportPromptTemplateEdit extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** 変数 */

  /** タブ */
  private tab = 0;

  /** 編集モード */
  private mode = "";

  /** プロンプトテンプレート */
  private promptTemplate: PromptTemplate = DefaultPromptTemplate();

  /** getter */

  /** コピーモード */
  private get IsCopyMode(): boolean {
    return this.mode == "copy";
  }

  /** 関数 */

  created() {
    this.mode = this.$route.query.mode as string;
    this.fetch();
  }

  /** プロンプトテンプレート取得 */
  private fetch() {
    const promptTemplateId = Number(this.$route.params.id);
    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/prompt/get",
      { id: promptTemplateId },
      async (res) => {
        this.promptTemplate = res.data.prompt_template;

        if (this.IsCopyMode) {
          this.promptTemplate.name += "のコピー";
          this.promptTemplate.comment = "";
        }
      }
    );
  }

  /** プロンプトテンプレート保存 */
  private async save() {
    // 既存テンプレートのコピー時はid=0にして新規作成扱い
    if (this.IsCopyMode) {
      this.promptTemplate.id = 0;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/prompt/save",
      { prompt_template: this.promptTemplate },
      async () => {
        this.moveToListPage();
      }
    );
  }

  /** プロンプトテンプレート削除 */
  private async deletePromptTemplate() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/prompt/delete",
      { prompt_template: this.promptTemplate },
      async () => {
        this.moveToListPage();
      }
    );
  }

  /** 編集キャンセル */
  private cancel() {
    this.moveToListPage();
  }

  /** 一覧画面に戻る */
  private moveToListPage() {
    this.$router.push({ path: "/ai-monthreport/prompt/list" });
  }
}
